import React, { PureComponent } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import withStyles from 'material-ui-next/styles/withStyles'
import classNames from 'classnames'
import { truncate } from 'lodash'
import {
  getTopBarConfig,
  getCategory,
  getTotalItems,
  getItemsLoading,
} from '../../selectors'
import { CircularProgress } from 'material-ui-next/Progress'
import Button from 'material-ui-next/Button'
import Icon from 'material-ui-next/Icon'
import { uiConfigureTopBar } from '../../actions'
import { getFilterAttributesByCategory } from '../../utils'
import { fade } from 'material-ui-next/styles/colorManipulator'
import { shouldShowGenereFilter } from '../../utils'
import DistrictFilter from './DistrictFilter'
import Search from './Search'
import AutoCompleteGenere from './AutoCompleteGenere'
import AutoCompleteAttribute from './AutoCompleteAttribute'

const styles = theme => ({
  container: {
    backgroundColor: theme.swapick.colors.secondaryToolbar,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  head: {
    height: 42,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    backgroundColor: theme.swapick.colors.mediumgrey,
    color: theme.swapick.colors.white,
  },
  scroll: {
    flex: 1,
    overflow: 'scroll',
    padding: 10,
  },
  btn: {
    height: 50,
    width: '100%',
    backgroundColor: 'blue',
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 5,
    paddingBottom: 10,
    display: 'inline-flex',
    backgroundColor: theme.swapick.colors.secondaryToolbar,
  },
  primarySpan: {
    color: fade(theme.swapick.colors.secondary, 1),
  },
  redSpan: {
    color: theme.swapick.colors.evilred,
  },
  mobileFilteriltersButton: {
    fontSize: 11,
    color: theme.swapick.colors.white,
    backgroundColor: theme.swapick.colors.energized,
    '&:hover': {
      backgroundColor: fade(theme.swapick.colors.energized, 0.9),
    },
  },
  filterBtn: {
    marginLeft: 'auto',
    backgroundColor: theme.swapick.colors.primary,
    '&:hover': {
      backgroundColor: fade(theme.swapick.colors.primary, 0.8),
    },
  },
  clearFiltersBtn: {
    backgroundColor: theme.swapick.colors.tomato,
    '&:hover': {
      backgroundColor: fade(theme.swapick.colors.tomato, 0.8),
    },
  },
  wrapper: {
    height: 32,
    width: '100%',
    position: 'relative',
    borderRadius: 2,
    background: fade(theme.swapick.colors.white, 0.65),
    '&:hover': {
      background: fade(theme.swapick.colors.white, 0.75),
    },
  },
  inputSearch: {
    font: 'inherit',
    padding: 0,
    paddingLeft: 8,
    paddingRight: 35,
    border: 0,
    display: 'block',
    verticalAlign: 'middle',
    whiteSpace: 'normal',
    background: 'none',
    margin: 0, // Reset for Safari
    color: theme.swapick.colors.lightblack,
    width: '100%',
    '&:focus': {
      outline: 0,
    },
  },
  district: {
    height: 46,
    width: '100%',
  },
  filtersInfoText: {
    paddingTop: 15,
    color: theme.swapick.colors.lightblack,
    width: '100%',
  },
})

class FiltersMobile extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      hideButtons: false,
    }
  }

  componentDidMount() {
    this.setBodyFiltersOpenOnMobile(this.props.openFilters)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.openFilters !== nextProps.openFilters) {
      this.setBodyFiltersOpenOnMobile(nextProps.openFilters)
    }
  }

  componentWillUnmount() {
    this.setBodyFiltersOpenOnMobile(false)
  }

  setBodyFiltersOpenOnMobile = open => {
    const body = window.document.getElementsByTagName('body')[0]
    if (open) {
      body.classList.add('filters-mobile-open')
    } else {
      body.classList.remove('filters-mobile-open')
    }
  }

  onFocusHideBtn = () => {
    this.setState({
      hideButtons: true,
    })
  }

  onBlurShowBtn = () => {
    this.setState({
      hideButtons: false,
    })
  }

  render() {
    const {
      classes,
      filterAttributes,
      category,
      uiConfigureTopBar,
      location,
      totalItems,
      isItemLoading,
      history,
    } = this.props
    const showGenereFilter = shouldShowGenereFilter(category)

    return (
      <div className={classes.container}>
        <div className={classes.head}>
          {isItemLoading ? (
            <CircularProgress color="accent" size={30} />
          ) : totalItems !== 0 ? (
            <h5>
              <span className={classes.primarySpan}>{totalItems}</span>
              <span> risultati</span>
            </h5>
          ) : (
            <h5>
              <span className={classes.redSpan}>Nessun Risultato</span>
            </h5>
          )}
        </div>
        <div className={classes.scroll}>
          <div className="w-100">
            <Search
              disableUnderline
              className={classes.wrapper}
              inputClassName={classes.inputSearch}
            />
          </div>

          {showGenereFilter && (
            <AutoCompleteGenere
              key={'genere'}
              placeholder={'Genere'}
              categoryId={category.id}
              onFocus={this.onFocusHideBtn}
              onBlur={this.onBlurShowBtn}
              fullWidth
              openToTop
            />
          )}

          {filterAttributes &&
            filterAttributes.map((attribute, i) => (
              <AutoCompleteAttribute
                label={truncate(attribute.descrizione, {
                  length: 43,
                })}
                key={attribute.chiave}
                attribute={attribute.chiave}
                onFocus={this.onFocusHideBtn}
                onBlur={this.onBlurShowBtn}
                fullWidth
                openToTop
              />
            ))}
          <div className={classes.district}>
            <DistrictFilter />
          </div>
          {!category && (
            <div className={classes.filtersInfoText}>
              Seleziona una categoria per avere più filtri.
            </div>
          )}
        </div>
        {!this.state.hideButtons && (
          <div className={classes.btn}>
            <Button
              className={classNames(
                classes.mobileFilteriltersButton,
                classes.clearFiltersBtn
              )}
              onClick={() => {
                uiConfigureTopBar({ openFilters: false })
                history.push(location.pathname)
              }}>
              <Icon className={classes.filterIcon}>delete_sweep</Icon>
              <span style={{ paddingLeft: 3 }}>Reset</span>
            </Button>
            <Button
              className={classNames(
                classes.mobileFilteriltersButton,
                classes.filterBtn
              )}
              onClick={() => {
                uiConfigureTopBar({ openFilters: false })
              }}>
              <Icon className={classes.filterIcon}>filter_list</Icon>
              <span style={{ paddingLeft: 3 }}>OK</span>
            </Button>
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const config = getTopBarConfig(state)
  const category = getCategory(state, config.match.params.category)
  const filterAttributes = category
    ? getFilterAttributesByCategory(category)
    : null

  return {
    filterAttributes,
    category,
    isItemLoading: getItemsLoading(state),
    totalItems: getTotalItems(state),
    openFilters: config.openFilters,
  }
}

export default withRouter(
  withStyles(styles)(
    connect(mapStateToProps, {
      uiConfigureTopBar,
    })(FiltersMobile)
  )
)



// WEBPACK FOOTER //
// ./src/common/TopBar/FiltersMobile.js